<div class="button-wrap joinbuttondiv">
    <button [hidden]="this.cloudRecorder" (click)="rejoin()" class="btn btn-primary">Rejoin</button>
    <span [hidden]="!this.cloudRecorder"><b>Recording Ended</b></span>
</div>
